module.exports = __webpack_public_path__ + "static/media/confirm_email.edf8472e.png";